import { AHB_WITHDRAW_REASON } from "core/consts";
import type { ValueOf } from "core/types";
import type Translations from "translations/types";
import { z } from "zod";

const WITHDRAW_REASON_OTHER_MAX_LENGTH = 600;

const withdrawReasonValues = Object.values(
  AHB_WITHDRAW_REASON,
) as ValueOf<typeof AHB_WITHDRAW_REASON>[];

export function createWithdrawMessageReasonSchema(translations: Translations) {
  return z
    .object({
      withdraw_reason: z
        .string()
        .min(1, translations.patientForms.withdrawReasonValidation),
      withdraw_reason_other: z
        .string()
        .trim()
        .max(WITHDRAW_REASON_OTHER_MAX_LENGTH),
    })
    .superRefine((values, ctx) => {
      if (
        values.withdraw_reason === AHB_WITHDRAW_REASON.OTHER &&
        !values.withdraw_reason_other
      ) {
        ctx.addIssue({
          code: "custom",
          message:
            translations.insuranceApp.eligibilityTab.sendDocuments.withdrawModal
              .validationOther,
          path: ["withdraw_reason_other"],
        });
      }

      if (
        values.withdraw_reason &&
        !withdrawReasonValues.includes(
          values.withdraw_reason as ValueOf<typeof AHB_WITHDRAW_REASON>,
        )
      ) {
        ctx.addIssue({
          code: "custom",
          message: translations.patientForms.withdrawReasonValidation,
          path: ["withdraw_reason"],
        });
      }
    });
}

export type WithdrawMessageReasonFormValues = z.infer<
  ReturnType<typeof createWithdrawMessageReasonSchema>
>;
